import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { useRecoilState } from 'recoil'
import connectionRequestsAtom from '@/pages/Equipment/atoms/connectionRequests.atom.ts'
import { useEffect, useState } from 'react'
import equipmentApi from '@/pages/Equipment/equipment.api.ts'
import {
  ILKDSConnectionRequest,
  ILPConnectionRequest,
  TConnectionRequestProtocol,
} from '@/pages/Equipment/equipment.types.ts'

interface IUseConnectionRequestsResult<T> {
  loading: boolean
  connectionRequests: T[]
}

function useConnectionRequests(protocol: 'lkds'): IUseConnectionRequestsResult<ILKDSConnectionRequest>
function useConnectionRequests(protocol?: 'lp-lift'): IUseConnectionRequestsResult<ILPConnectionRequest>
function useConnectionRequests(protocol: TConnectionRequestProtocol = 'lp-lift') {
  const { wait, loading } = useHttpLoader()
  const [state, setState] = useRecoilState(connectionRequestsAtom)
  const [lkdsState, setLkdsState] = useState<{ items: ILKDSConnectionRequest[]; loaded: boolean }>({
    items: [],
    loaded: false,
  })

  useEffect(() => {
    if (protocol !== 'lp-lift') return
    if (state.loaded) return

    wait(equipmentApi.getConnectionRequests(), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: resp.body.items, loaded: true }))
      }
    })
  }, [protocol])

  useEffect(() => {
    if (protocol !== 'lkds') return
    if (lkdsState.loaded) return

    wait(equipmentApi.getConnectionRequestsLKDS(), (resp) => {
      if (resp.status === 'success') {
        setLkdsState({ items: resp.body.items, loaded: true })
      }
    })
  }, [protocol, lkdsState.loaded])

  return { loading, connectionRequests: protocol === 'lkds' ? lkdsState.items : state.items }
}

export default useConnectionRequests
